import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useBrand } from "@/context/BrandContext";

export default function EditionLink() {
  const { slug } = useParams();
  const { chooseBrand } = useBrand();
  useEffect(() => {
    chooseBrand(slug);
  }, [slug]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Navigate to="/" replace />;
}
